// src/utils/httpInterceptor.ts

/**
 * Force HTTP to HTTPS conversion for production environments
 */
export function setupHttpsInterceptor(): void {
  // Only apply in production and secure browser environments
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    // Save original fetch
    const originalFetch = window.fetch;

    // Override global fetch with proper typing
    window.fetch = function(
      input: RequestInfo | URL,
      init?: RequestInit
    ): Promise<Response> {
      if (typeof input === 'string') {
        // Force HTTPS for all absolute URLs to our API domains
        if (input.startsWith('http:') &&
            (input.includes('digitalaim.onrender.com') ||
             input.includes('thedigitalaim.com'))) {
          const secureUrl = input.replace('http:', 'https:');
          return originalFetch(secureUrl, init);
        }
      }
      return originalFetch(input, init);
    };

    // Also override XMLHttpRequest for older code
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(
      this: XMLHttpRequest,
      method: string,
      url: string | URL,
      async: boolean = true,
      username?: string | null,
      password?: string | null
    ): void {
      if (typeof url === 'string' && url.startsWith('http:') &&
          (url.includes('digitalaim.onrender.com') ||
           url.includes('thedigitalaim.com'))) {
        const secureUrl = url.replace('http:', 'https:');
        return originalOpen.call(this, method, secureUrl, async, username, password);
      }
      return originalOpen.call(this, method, url, async, username, password);
    };
  }
}